@if (showLogin) {
    @if (!isMobile) {
        @if (enableMenu) {
            @if (!isAuthenticated) {
                <a mat-button [matMenuTriggerFor]="dropdown">
                    <mat-icon aria-label="Login" class="md-icon-18">account_circle</mat-icon>
                    LOGIN
                </a>
            }
            @if (isAuthenticated) {
                <a mat-button [matMenuTriggerFor]="dropdown">
                    <mat-icon aria-label="Login" class="md-icon-18">account_circle</mat-icon>
                    {{ userName }}
                </a>
            }
            <mat-menu #dropdown class="menu-login mat-menu-panel">
                @if (!!administrativeLoginURL) {
                    <a mat-menu-item [href]="administrativeLoginURL | sanitize: 'url'" target="_NEW">
                        Administrative login
                    </a>
                }
                @if (!isAuthenticated) {
                    <a mat-menu-item [routerLink]="['/login']" routerLinkActive="router-link-active">
                        SprintPay login
                    </a>
                }
                @if (isAuthenticated) {
                    <button (click)="logOut()" mat-menu-item routerLinkActive="router-link-active">Log out</button>
                }
            </mat-menu>
        } @else {
            @if (!isAuthenticated) {
                <a mat-button [routerLink]="['/login']" routerLinkActive="router-link-active">
                    <mat-icon aria-label="Login" class="md-icon-18">account_circle</mat-icon>
                    LOGIN
                </a>
            }
            @if (isAuthenticated) {
                @if (!smallQuery.matches) {
                    <a mat-button [matMenuTriggerFor]="dropdown">
                        <mat-icon aria-label="Login" class="md-icon-18">account_circle</mat-icon>
                        {{ userName }}
                    </a>
                } @else {
                    <button matIconButton [matMenuTriggerFor]="dropdown" [matTooltip]="userName" id="btn-account">
                        <mat-icon>account_circle</mat-icon>
                    </button>
                }
                <mat-menu #dropdown class="menu-login mat-menu-panel">
                    @if (isAuthenticated) {
                        <button (click)="logOut()" mat-menu-item routerLinkActive="router-link-active">Log out</button>
                    }
                </mat-menu>
            }
        }
    } @else {
        @if (!!administrativeLoginURL && isMobile) {
            <a
                (click)="toggleRightSidenav()"
                mat-list-item
                [href]="administrativeLoginURL | sanitize: 'url'"
                target="_NEW"
            >
                <mat-icon aria-label="Login" class="md-icon-18"> account_circle </mat-icon>
                ADMINISTRATIVE LOGIN
            </a>
        }
        @if (!isAuthenticated) {
            @if (isMobile) {
                <a
                    (click)="toggleRightSidenav()"
                    mat-list-item
                    [routerLink]="['/login']"
                    routerLinkActive="router-link-active"
                >
                    <mat-icon aria-label="Login" class="md-icon-18"> account_circle </mat-icon>
                    CARGOSPRINT SPRINTPAY LOGIN
                </a>
            }
        }
        @if (isAuthenticated) {
            @if (isMobile) {
                <button (click)="logOut()" mat-list-item routerLinkActive="router-link-active">
                    <mat-icon aria-label="Login" class="md-icon-18"> account_circle </mat-icon>
                    LOG OUT
                </button>
            }
        }
    }
}
